import { FolderDTO, FolderStruct } from './types';

const getStructure = <T>(
  foldersByParentId: Record<string, FolderDTO<T>[]>,
  currentFolder: FolderDTO<T>,
  parentFolder: FolderStruct<T> | null,
  level: number,
  folderById: Record<string, FolderStruct<T>>,
  addToSet?: (id: string) => void
): FolderStruct<T> => {
  const descendantIds = new Set<string>();
  const addDescendant = (id: string) => {
    descendantIds.add(id);
    addToSet?.(id);
  };

  const currentFolderStruct: FolderStruct<T> = {
    ...currentFolder,
    parentFolder,
    subfolders: [],
    level,
    descendantIds,
    folderById,
  };

  folderById[currentFolder.id] = currentFolderStruct;

  currentFolderStruct.subfolders = (
    foldersByParentId[currentFolder.id] || []
  ).map((f) => {
    addDescendant(f.id);
    return getStructure(
      foldersByParentId,
      f,
      currentFolderStruct,
      level + 1,
      folderById,
      addDescendant
    );
  });
  return currentFolderStruct;
};

export const getFolderStructure = <T>(
  folders: FolderDTO<T>[],
  rootFolder: FolderDTO<T>
): FolderStruct<T> => {
  const foldersByParentId: Record<string, FolderDTO<T>[]> = folders.reduce<
    Record<string, FolderDTO<T>[]>
  >((acc, folder) => {
    if (folder.parentId) {
      acc[folder.parentId] ??= [];
      acc[folder.parentId].push(folder);
    }
    return acc;
  }, {});

  return getStructure(foldersByParentId, rootFolder, null, 0, {});
};
